module.exports = __webpack_public_path__ + "static/media/Ba-Ya-Thae.1c331d00.png";